import fetch from 'utils/fetch';

export const create = (id, json) => {
  return fetch(`/pco-manager/aast/cases/${id}/contract/organize`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const createValidate = (id, json) => {
  return fetch(`/pco-manager/aast/cases/${id}/contract/organize/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/contract/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const validate = (id, json) => {
  return fetch(`/pco-manager/aast/cases/contract/${id}/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/organize/api/index.js